import AmplitudeHelper from '@utils/analytics';
import { AMPLITUDE_CONSTANTS, AMPLITUDE_EVENT_SOURCES } from '@utils/analytics/constants';

export function logLogoutClicked(): void {
  const e = AMPLITUDE_CONSTANTS.ProfilePage.logout_clicked;
  AmplitudeHelper.logEvent(e.name, { [e.attributes.source]: AMPLITUDE_EVENT_SOURCES.others_page });
}

export function logoutConfirmedClicked(): void {
  const e = AMPLITUDE_CONSTANTS.ProfilePage.logout_confirm_clicked;
  AmplitudeHelper.logEvent(e.name, { [e.attributes.source]: AMPLITUDE_EVENT_SOURCES.others_page });
}

export function logCloseModal(type: string): void {
  const e = AMPLITUDE_CONSTANTS.ProfilePage.logout_cancelled_clicked;
  AmplitudeHelper.logEvent(e.name, {
    [e.attributes.source]: AMPLITUDE_EVENT_SOURCES.others_page,
    [e.attributes.button]: type,
  });
}
